var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#da000c",
    width: 512,
    height: 256
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 512,
    height: 171.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "castle_half",
    fill: "#da000c",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    stroke: "none",
    width: 64,
    height: 43.992859,
    x: 196.57106,
    y: 116.30338
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.81889,153.86465H190.75L182.08989,159.56444V165.60411H229.81889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.46875,128.59375C219.09357,128.59375 223.6875,133.28303 223.6875,139.0625V153.84375H231.03125V97.84375H190.75V153.84375H203.25V139.0625C203.24999,133.50878 207.76491,128.59375 213.46875,128.59375z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    stroke: "none",
    width: 18.523308,
    height: 33.9594,
    x: 204.5282,
    y: 59.961655
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,88.65625H206.79108V82.90625H194.90625V88.65625H186.84375V82.90625H182.03125V93.34375H223M186.84375,93.306038H221.81414V97.843752H186.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.71875,47.625V82.90625H206.79108V73.21875C206.79108,69.589448 209.35314,66.619386 212.9375,66.4375C213.05312,66.431633 213.16418,66.4375 213.28125,66.4375C217.02763,66.437497 220.0625,69.472374 220.0625,73.21875V82.90625H225.84375V47.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.53125,42.84375V47.625H227.78125V42.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.78125,33.6875V42.84375H229.875V33.6875H224.46875V38.34375H217.9375V33.6875H207.96875V38.34375H201.4375V33.6875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.08989,159.56444H230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,156.8125H228.5625L218.78125,161.53125V168.5625H261"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    d: "M218.771,161.51923H262"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#castle_half",
    transform: "matrix(-1,0,0,1,512,0)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f8d80e"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.768,
    d: "m273.297,150.031c-2.65428,0.88339-5.05329,2.369-7.46888,3.75283-3.1004,1.83163-6.10683,3.82731-8.90451,6.09885-0.98462,0.64912-1.92929,1.36065-2.68911,2.27332-1.02583,0.8776-2.06486,2.05478-1.86885,3.51297,0.0518,0.64315,0.87359-0.75523,1.41401-0.82297,0.94235-0.54095,2.0838-0.7154,3.14219-0.4713,1.27117-1.33857,2.90994-2.23563,4.3249-3.40609,3.00467-2.24222,6.23664-4.16769,9.52502-5.96082,1.1481-0.58838,2.30104-1.18568,3.52508-1.60184-0.33328-1.12498-0.66657-2.24997-0.99985-3.37495z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.40041,157.3913V161.3032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.81691,155.68544V159.56821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.23339,154.17984V158.03797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64986,152.69367V156.67498"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.768,
    d: "m238.891,150.156c-0.39583,1.10417-0.79167,2.20833-1.1875,3.3125,5.53699,2.10036,10.8089,4.87874,15.7978,8.06036,1.69067,1.15075,3.46718,2.26632,4.79593,3.84589,0.2927,0.81098-0.51392,1.48903-1.31413,1.24403-0.73225-0.24871-1.45351-0.53169-2.22629-0.004-1.10637,0.50311-2.10598,2.1416-0.42575,2.69112,2.31528,1.55489,6.08158,0.87915,7.19454-1.84522,0.58146-1.40134,0.61878-3.19523-0.50753-4.34456-2.06261-2.36404-4.79728-4.00804-7.4215-5.67182-4.68917-2.82023-9.57283-5.37389-14.7055-7.28801z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.04985,158.03521 253.73747,161.37469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.8319,159.73914 255.96991,163.00882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.80442,162.01152 257.99552,164.54884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71528,168.18078 258.10512,166.78032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.52792,165.42898 258.53251,165.70943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.66497,169.7646 257.45987,167.13228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.56809,166.75559 254.09509,168.57779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.67669,152.9368V156.05184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.96338,156.24386V159.77805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82004,154.59318V157.9121"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.78125,227.5625V235.59375H240.8125V231.5625H247.65625V235.59375H253.0625V227.5625zM235.78125,238.625V246.6875H253.0625V238.625H247.65625V242.65625H240.8125V238.625z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.9902272,
    height: 58.115017,
    x: 253.05186,
    y: 193.65144
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.9902272,
    height: 50.060368,
    x: 253.05186,
    y: 198.6788
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.024,
    d: "M255.54688,179.40625 266.17188,185.59375 255.54688,191.75 244.92188,185.59375zM241.32813,183.375H238.54688V187.8125H241.32813L255.54688,196.0625 269.76563,187.8125H272.54688V183.375H269.76563L255.54688,175.125z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.024,
    d: "m255.344,164.281c-2.41872,0.33922-4.22593,2.73018-4.09375,5.13412,0.009,3.73773-0.0185,7.47634,0.0141,11.2135,0.12824,2.40829,2.23219,4.56615,4.6744,4.58823,1.98493,0.18804,3.97892-0.97232,4.81154-2.77961-0.57292-0.34375-1.14583-0.6875-1.71875-1.03125-0.44378,1.18388-1.72345,1.91762-2.96875,1.78125-1.63507,0.046-2.95917-1.54398-2.8125-3.13412,0.01-3.71344-0.0192-7.42801,0.0146-11.1407,0.0899-1.5151,1.53488-2.75487,3.04795-2.60016,0.6265-0.17973,1.48748,0.67715,1.8747-0.0623,0.5838-0.82944-0.41442-1.47737-0.96875-1.9374-0.61348-0.0841-1.25418-0.008-1.8747-0.0316zm5.78125,3.90625c-0.39638,0.7459-1.21626,1.18923-1.875,1.58041v7.51334c0.66667,0.38542,1.33333,0.77083,2,1.15625-0.008-3.20377,0.0153-6.40813-0.0117-9.61152-0.0315-0.19722-0.008-0.4984-0.11328-0.63848z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#da000c"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    stroke: "none",
    width: 29.328571,
    height: 53.254513,
    x: 240.80301,
    y: 38.351128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75,38.375V82.9375H248.0625V69.71875C248.0625,66.669822 250.01501,62.4375 256,62.4375C261.98499,62.4375 263.9375,66.669822 263.9375,69.71875V82.9375H273.25V38.375zM254.5625,43.375H257.4375V58.625H254.5625zM246.3125,46.375H249.21875V57.53125H246.3125zM262.78125,46.375H265.6875V57.53125H262.78125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59375,31.96875V38.3125H276.40625V31.96875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75,24.59375V31.96875H280.25V24.59375H274.15625V28.65625H267.28125V24.59375H259.4375V28.65625H252.5625V24.59375H244.71875V28.65625H237.84375V24.59375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.75,97.84375V102.4375H289.25V97.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.03125,82.90625V97.84375H291.96875V82.90625H285.15625V88.65625H276.09375V82.90625H263.9375V88.65625H248.0625V82.90625H235.90625V88.65625H226.84375V82.90625z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M228.6875,102.4375V156.78125H241.53125V136.4375C241.53125,126.85477 247.92755,122.34375 256,122.34375C263.75894,122.34375 270.46875,126.85477 270.46875,136.4375V156.78125H283.3125V102.4375z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/gi.a87ba99e6a20309b6e82aad26249470c.svg";
export { ForwardRef as ReactComponent };